import { db } from "@/indexedDB/db";
import { MessageEntity } from "../types";
import Dexie from "dexie";

// Add message
export const addPinnedMessageToLocalDB = async (message: MessageEntity) => {
  return await db.pinnedMessages.put(message);
};

// update pinned message by server id (primary key)
export const updatePinnedMessageByServerIdInLocalDB = async (
  id: string, // server id (primary key)
  message: Partial<MessageEntity>,
) => {
  return await db.pinnedMessages.update(id, message);
};

// Remove all pinned messages by chat id
export const removePinnedMessagesByChatIdFromLocalDB = async (
  chatId: string,
) => {
  return await db.pinnedMessages.where("chatId").equals(chatId).delete();
};

// remove pinned message by server id (primary key)
export const removePinnedMessageByServerIdFromLocalDB = async (id: string) => {
  return await db.pinnedMessages.delete(id);
};

// Bulk add pinned message list
export const addPinnedMessagesToLocalDB = async (
  messageList: MessageEntity[],
) => {
  return await db.pinnedMessages.bulkPut(messageList);
};

// Get pinned messages by chatId / descending order of creation (UUID7-based id)
export const getPinnedMessagesByChatIdFromLocalDB = async (chatId: string) => {
  return await db.pinnedMessages
    .where("[chatId+id]")
    .between([chatId, Dexie.minKey], [chatId, Dexie.maxKey])
    .reverse()
    .toArray();
};

// get pinned message by server id (primary key)
export const getPinnedMessageByServerIdFromLocalDB = async (id: string) => {
  return await db.pinnedMessages.get(id);
};

// Get total message count by chatId
export const getPinnedMessageCountByChatIdFromLocalDB = async (
  chatId: string,
) => {
  return await db.pinnedMessages
    .where("chatId")
    .equals(chatId)
    .count()
    .then((count) => count);
};
